// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6584":"d7417318","9699":"a1695945"}[chunkId] + ".chunk.css";
};